import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <>
      {/* Top Banner */}
      <div className="bg-white border-b border-neutral-200 py-2 px-4 text-center">
        <p className="text-xs md:text-sm text-neutral-600">
          Luxury Gifting Brand | Free Standard Shipping across India | Made with Intention and Care
        </p>
      </div>

      {/* Main Header */}
      <header className="bg-white sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-3xl md:text-4xl font-serif tracking-wider text-neutral-800">
                  GURIVA
                </h1>
                <div className="h-px w-32 bg-neutral-300 mx-auto mt-2"></div>
                <p className="text-xs tracking-widest text-neutral-600 mt-2 font-light">
                  Crafted with intention, wrapped in emotion
                </p>
              </div>
            </Link>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;